'use client';

import React, { useEffect, useRef } from 'react';

const testimonial = {
  quote:
    "EarnestBridge funded our $350K EMD in under 40 hours. We had two other deals in escrow at the same time — there's no way we could have done that without them.",
  name: 'Marcus Delacroix',
  title: 'Managing Partner',
  stat: '$350K EMD · 40hr funding',
};

export default function TestimonialSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const el = ref.current;
          if (el) {
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
          }
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      id="testimonials"
      className="py-24 px-6 relative z-10"
      style={{ background: 'var(--color-bg-alt)' }}
      aria-label="Customer testimonials and success stories"
    >
      <div className="max-w-5xl mx-auto">
        <div
          ref={ref}
          className="text-center"
          style={{
            opacity: 0,
            transform: 'translateY(32px)',
            transition: 'all 1s cubic-bezier(0.16,1,0.3,1)',
          }}
        >
          {/* Quote mark */}
          <div
            className="font-display text-8xl leading-none mb-6 select-none"
            style={{ color: 'rgba(82,183,136,0.25)' }}
            aria-hidden="true"
          >
            &ldquo;
          </div>

          <blockquote
            className="font-display italic mb-10 max-w-3xl mx-auto"
            style={{
              fontSize: 'clamp(1.25rem, 2.5vw, 1.875rem)',
              color: 'var(--color-foreground)',
              lineHeight: 1.4,
            }}
          >
            {testimonial?.quote}
          </blockquote>

          <div className="flex items-center justify-center gap-4 flex-wrap">
            <div
              className="w-12 h-px"
              style={{ background: 'var(--color-accent)' }}
            />
            <div className="text-center">
              <p
                className="text-[11px] font-bold uppercase tracking-[0.35em]"
                style={{ color: 'var(--color-foreground)' }}
              >
                {testimonial?.name}
              </p>
              <p
                className="text-[10px] font-medium uppercase tracking-[0.25em] mt-0.5"
                style={{ color: 'var(--color-muted)' }}
              >
                {testimonial?.title}
              </p>
            </div>
            <div
              className="w-12 h-px"
              style={{ background: 'var(--color-accent)' }}
            />
          </div>

          <div className="mt-8">
            <span
              className="pill-badge"
              style={{ background: 'rgba(27,67,50,0.08)', color: 'var(--color-primary)' }}
            >
              {testimonial?.stat}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}